export default {
  subclassPlacementRadioItems: {
    buttonItems: [
      {
        id: 'above',
        textLabel: '上方新增',
      },
      {
        id: 'below',
        textLabel: '下方新增',
      },
    ],
  },
  subclassBatchSequenceFailTitle:
    '排序更新失敗，子領域已建立，請稍後再試，或使用「排序」功能調整順序。',
  managementTitle: '領域管理',
  createPopupTitles: {
    create: '新增領域',
    update: '編輯領域',
    createSubclass: '新增子領域',
    createSubclassInside: '新增子領域',
    updateSubclass: '編輯子領域',
  },
  deleteShowErrorContentText: '取得引用資訊失敗，請稍後再試',
  dataTableSortBtnText: '排序',
  formNameTitle: '名稱',
  formNamePlaceholder: '輸入',
  disabledLabel: '已停用',
  tooltipSubclassEnable: '啟用',
  tooltipSubclassDisable: '停用',
  tooltipSubclassAdd: '新增',
  tooltipSubclassEdit: '編輯',
  tooltipSubclassDelete: '刪除',
  deleteInUseContentText: '下列項目正在使用此領域，無法刪除',
  index: {
    columnHeader: [
      {
        id: 'systemClass',
        textLabel: '領域',
        type: 'text-chip',
        tabletHide: false,
        textMaxWidth200: true,
      },
      {
        id: 'systemSubclasses',
        textLabel: '子領域(紅字為已停用)',
        type: 'chips',
        tabletHide: false,
        column: false,
      },
      {
        id: 'updatedUser',
        textLabel: '更新者',
        type: 'avatar',
        tabletHide: true,
      },
      {
        id: 'updatedAt',
        textLabel: '更新時間',
        type: 'text',
        tabletHide: true,
      },
    ],
    filterFieldTypes: [
      {
        name: 'search',
        type: 'search',
      },
      {
        name: 'updatedUser',
        type: 'avatars',
      },
      {
        name: 'duration',
        type: 'date-duration',
        title: '更新時間',
        defaultValue: {
          start: '',
          end: '',
        }
      },
    ],
  },
};
